//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { colorLuminance } from "../utils/utils";
export default {
  name: 'FibStatus',
  components: {},
  props: {
    active: {
      type: Boolean,
      default: false
    },
    clickable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    theme: function theme() {
      return this.$store.getters['theme/theme'];
    },
    disabledStyle: function disabledStyle() {
      return {
        backgroundColor: colorLuminance(this.theme.greyColor, 0.4),
        borderColor: colorLuminance(this.theme.greyColor, 0.4)
      };
    }
  },
  methods: {
    handleClick: function handleClick() {
      if (this.clickable) {
        this.$emit('click', this.text);
      }
    }
  }
};